import { svg } from 'lit';

const symbol = svg`<svg width="25" height="13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.1 1.202L12.4 12.577.52 1.202" stroke="currentcolor" stroke-width=".5" stroke-linecap="square"/></svg>`;

export { symbol as default };
